export const BASE_URL_BACKEND = `https://rs-react-schedule.firebaseapp.com/api/team`;
export const TEAM_ID = `/team06`;
